.moneyBack_wrapper {
  width: 100%;
  padding: 21px 20px 0 20px;
  margin-bottom: 85px;

  .moneyBack_text1 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    color: #00a36f;
    text-align: center;
    font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
      sans-serif);
    font-size: 10px;
    font-style: normal;
    font-weight: 800;
    line-height: 14px;
    letter-spacing: 0.4px;
    text-transform: uppercase;

    &::before {
      content: '';
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-right: 2px;
      background-image: url('./img/icon1.svg');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
      position: relative;
      top: -1px;
    }
  }

  .moneyBack_block {
    position: relative;
    margin-top: 19px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 20px 16px 36px 16px;
    border: 4px solid var(--ed-border, #00a66b);
    border-radius: 32px;

    &::after {
      content: '';
      display: block;
      width: 100%;
      height: 82px;

      position: absolute;
      bottom: -56px;
      left: 0;
      right: 0;

      background-image: url('./img/icon2.png');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
      z-index: 1;
    }
  }

  .moneyBack_text2 {
    color: #1a1a1a;
    text-align: center;
    font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
      sans-serif);
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 29px;
  }

  .moneyBack_text3 {
    margin-top: 10px;
    color: #7b766f;
    text-align: center;
    font-family: 'SF Pro', -apple-system, 'Roboto', sans-serif;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.1px;
  }

  .moneyBack_text4 {
    margin-top: 20px;
    color: #7b766f;
    text-align: center;
    font-family: 'SF Pro', -apple-system, 'Roboto', sans-serif;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.1px;

    a {
      text-decoration-line: underline;
    }
  }
}

.moneyBack_wrapper_style2 {
  margin-bottom: 70px;

  .moneyBack_text1,
  .moneyBack_text2 {
    color: #fff;
  }

  .moneyBack_text3,
  .moneyBack_text4 {
    color: #fff;
    opacity: 0.8;
  }

  .moneyBack_block {
    margin-bottom: 70px;
    border-color: #ff8600;
  }

  .moneyBack_text1 {
    &::before {
      filter: brightness(0) invert(1);
    }
  }
}

// Dark mode
:global body.dark {
  :local {
    .moneyBack_text2 {
      color: #fffbf2;
    }
  }
}
